import { Component, OnInit, ElementRef, ViewChild, Input } from '@angular/core';
import { RGuestMessages } from 'model/shared/backend-api-response/rguest-messages';
import { GoogleAnalyticsEventsService } from 'modules/shared/legacy-bookexpress/services/google-analytics-events.service';
import { ValidateLoyaltyService } from 'modules/shared/legacy-bookexpress/services/validate-loyalty.service';
import { LegacyBookInitService } from 'modules/shared/legacy-bookexpress/services/legacy-book-initializer.service';
import { Permissions } from 'model/shared/backend-api-response/permissions';
import { RoomlistService } from 'modules/shared/legacy-bookexpress/services/RoomList.service';
import { ReservationService } from 'modules/shared/legacy-bookexpress/services/reservation.service';
import { GetRoomsResponse } from 'model/wbe/backend-api-response/get-rooms-response';
import { Reservation } from 'model/shared/backend-api-response/reservation';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { PolicyModalComponent } from 'modules/shared/legacy-bookexpress/components/policy-modal/policy-modal.component';
import { ModifyReservationsService } from 'modules/shared/services/modify-reservations.service';
import { BookService } from 'modules/shared/legacy-bookexpress/services/book.service';
import { Roomdata } from 'modules/book/legacy-components/room/room.component';
import { GuestCountKeys } from '../../model/global-enum.model';
import { ToastrService } from 'ngx-toastr';
import * as _ from 'lodash';
import * as moment from 'moment';
import { DateAdapter } from '@angular/material/core';

@Component({
  selector: 'app-room-selection',
  templateUrl: './room-selection.component.html',
  styleUrls: ['./room-selection.component.scss'],
})
export class RoomSelectionComponent implements OnInit {
  rGuestBookMessages: RGuestMessages;
  rGuestBookRoutePermissions: Permissions;
  @Input() currencyDet;
  arrivalDate: any;
  departureDate: any;
  offerCode: string;
  casinoNumber = '';
  refineSearchGuestCount: any;
  reservationData: Reservation;
  guestAdultCount = 1;
  guestJuniorCount = 0;
  guestChildCount = 0;
  guestInfantCount = 0;
  guestDiscInfantCount = 0;
  public filteredItems = [];
  previousRoom = '';
  previousIndex: number;
  closedvalue = true;
  public showMore = false;
  propertyId = '';
  scrollfix: number;
  room: Array<any> = [];
  windowWidth: any;
  defaultHeight: number;
  fullscreenView = false;
  details_tab = false;
  public roomList = [];
  errorPopup = '';
  newRate: any = 1;
  defaultRoomImageURL: any;
  selectedTab: any;
  @ViewChild('depositAndCancellationBtn') private depositAndCancellationBtn: ElementRef;
  assetsURL = '';
  showRemainingRoomsCount = false;
  isLoading = false;
  @Input() data: any;
  updatedRoomCode = '';
  currencyCode: any;
  countryCode: any;
  GuestCountKeys: any = {};
  private defaultDialCode = '+1';

  constructor(
    public validateloyaltyService: ValidateLoyaltyService,
    public googleAnalyticsEventsService: GoogleAnalyticsEventsService,
    public configService: LegacyBookInitService,
    public roomService: RoomlistService,
    public reservationService: ReservationService,
    private dialog: MatDialog,
    private modifiyResService: ModifyReservationsService,
    private bookService: BookService,
    private adapter: DateAdapter<any>,
    public toastr: ToastrService
  ) {
    this.reservationData = this.reservationService.reservationData;
    this.setDates();
    this.offerCode = this.reservationData.offers[0].offer;
    this.casinoNumber = this.reservationData.guestInfo[0].casinoNumber;
    this.guestAdultCount = this.reservationData.stayInfo.guestCounts.adults;
    this.guestJuniorCount = this.reservationData.stayInfo.guestCounts.juniors;
    this.guestChildCount = this.reservationData.stayInfo.guestCounts.children;
    this.guestInfantCount = this.reservationData.stayInfo.guestCounts.infants;
    this.GuestCountKeys = GuestCountKeys;
    this.updateGuestCount();
    this.adapter.setLocale(this.configService.PropertyData?.dateFunctionConfig.locale);
  }

  ngOnInit(): void {
    // Currency Conversion Logic
    if (this.currencyDet?.currencyCode == 'USD' || this.currencyDet === 'USD') {
      this.newRate = 1;
      this.currencyCode = 'USD';
    } else {
      this.newRate = this.currencyDet['currencyValue'];
      this.currencyCode = this.currencyDet['currencyCode'];
      this.countryCode = this.currencyDet['countryCode'];
    }
    this.setDefaultDialCode();
    this.rGuestBookRoutePermissions = this.configService?.PropertyData?.permissions;
    this.rGuestBookMessages = this.roomService?.CommonService?.PropertyData?.rGuestMessages;
    this.defaultRoomImageURL = this.configService?.PropertyData?.UrlMap?.defaultRoomImageUrl;
    this.assetsURL = this.configService?.PropertyData?.UrlMap?.ImageUrl;
    // Initial call to populate the rooms based on previous reservation data
    this.getRooms(true);
  }

  setHeight(data) {
    this.defaultHeight = data;
  }

  setWidth(data) {
    this.windowWidth = data;
  }

  fetchValues(detail) {
    const array = [];
    let startValue = 0;
    if (detail.key === 'adults') {
      startValue = 1;
    }
    for (let i = startValue; i <= detail.maxCount; i++) {
      array.push(i);
    }
    return array;
  }

  triggerDateChanged() {
    this.modifiyResService.inValidModifyRoomSelection = '';
    if (this.arrivalDate && this.departureDate) {
      this.getRooms();
    } else if (!this.departureDate) {
      this.modifiyResService.inValidModifyRoomSelection =
        this.configService?.PropertyData?.rGuestMessages?.groups?.departureDateEmptyErrorText;
      this.toastr.error(this.modifiyResService.inValidModifyRoomSelection);
    }
  }
  resetDatePicker() {
    this.setDates();
    this.triggerDateChanged();
  }
  setDates() {
    let arrDate = this.reservationData.stayInfo.arrivalDate.split('-');
    let depDate = this.reservationData.stayInfo.departureDate.split('-');
    this.arrivalDate = new Date(+arrDate[0], +arrDate[1] - 1, +arrDate[2]);
    this.departureDate = new Date(+depDate[0], +depDate[1] - 1, +depDate[2]);
  }
  getGuestDetails(detail, val) {
    detail.selectedValue = val.value;
    this.refineSearchGuestCount = 0;
    this.configService?.guestTypeLimit.forEach((element) => {
      if (element.selectedValue) {
        this.refineSearchGuestCount += Number(element.selectedValue);
      }
    });
    this.getRooms();
  }

  getRooms(isInitialCall = false) {
    this.modifiyResService.inValidModifyRoomSelection = '';
    // isInitialCall is used to find whether the call is 1st time to assign the Old data to seperate obj for comparison
    if (
      !this.reservationData?.canBeAllowedToModify?.[0].arrivalDate &&
      moment(this.reservationData.stayInfo.arrivalDate).format('YYYY-MM-DD') !== moment(this.arrivalDate).format('YYYY-MM-DD')
    ) {
      this.toastr.error(this.configService?.PropertyData?.rGuestMessages?.groups?.arrivalChangeRestrictionText);
      this.modifiyResService.inValidModifyRoomSelection =
        this.configService?.PropertyData?.rGuestMessages?.groups?.arrivalChangeRestrictionText;
      return false;
    }
    if (
      !this.reservationData?.canBeAllowedToModify?.[0].departureDate &&
      moment(this.reservationData.stayInfo.departureDate).format('YYYY-MM-DD') !== moment(this.departureDate).format('YYYY-MM-DD')
    ) {
      this.toastr.error(this.configService?.PropertyData?.rGuestMessages?.groups?.departureChangeRestrictionText);
      this.modifiyResService.inValidModifyRoomSelection =
        this.configService?.PropertyData?.rGuestMessages?.groups?.departureChangeRestrictionText;
      return false;
    }
    this.isLoading = true;
    this.details_tab = false;
    let setRoomValue: any;
    this.errorPopup = '';
    this.errorPopup = '';
    if (this.configService?.multiGuestType) {
      setRoomValue = this.configService?.guestTypeLimit;
    } else {
      setRoomValue = this.guestAdultCount;
    }
    this.roomService
      .getRooms(
        moment(this.arrivalDate).format('YYYY-MM-DD'),
        moment(this.departureDate).format('YYYY-MM-DD'),
        this.offerCode,
        this.casinoNumber,
        setRoomValue,
        this.reservationData.guestInfo[0]?.firstName,
        this.reservationData.guestInfo[0]?.lastName,
        this.configService?.multiGuestType
      )
      .subscribe(
        (roomLists: GetRoomsResponse) => {
          if (roomLists.Success) {
            this.processRooms(roomLists, isInitialCall);
          } else {
            this.isLoading = false;
            this.filteredItems = [];
            this.errorPopup =
              roomLists?.ErrorMessage ||
              roomLists?.messages?.[0]?.messageText ||
              this.rGuestBookMessages?.rooms?.RoomNotAvailableErrorMsg ||
              'Room not available';
          }
        },
        (error) => {
          this.isLoading = false;
          console.log(error);
        }
      );
  }

  processRooms(roomLists, isInitialCall) {
    this.filteredItems = this.roomList = roomLists.offers[0].roomTypes;
    let existingSelectedRoomIndex = -1;
    this.showRemainingRoomsCount = roomLists.offers[0].showRemainingRoomsCount;

    let alreadySelectedRoom = this.reservationData.offers[0].wing + this.reservationData.offers[0].roomType;
    this.filteredItems = this.filteredItems.filter((eachRoom, index) => {
      if (alreadySelectedRoom === eachRoom.roomCode) {
        existingSelectedRoomIndex = index;
        eachRoom.alreadySelected = true;
        eachRoom.blockRoom = false;
        if (
          eachRoom?.blockRoom &&
          (!moment(this.reservationData.stayInfo.arrivalDate).isSame(this.arrivalDate, 'day') ||
            !moment(this.reservationData.stayInfo.departureDate).isSame(this.departureDate, 'day'))
        ) {
          eachRoom.alreadySelected = false;
          eachRoom.blockRoom = true;
          existingSelectedRoomIndex = -1;
          this.modifiyResService.updatedRoom = [];
        }
      }
      return eachRoom;
    });

    // To move already selected Room to top
    this.moveSelectedRoomToTop(existingSelectedRoomIndex, isInitialCall);

    // To Check Allowed to modify the Room Selection. Show only selected Room if not allowed to modify
    this.allowRoomsChangeCheck();

    this.setCouroselTimer();

    this.isLoading = false;
  }

  setCouroselTimer() {
    setTimeout(() => {
      (<any>$('.carousel')).carousel();
    }, 300);
  }

  allowRoomsChangeCheck() {
    if (!this.reservationData?.canBeAllowedToModify?.[0]?.roomType) {
      this.filteredItems = this.filteredItems?.filter((eachRoom) => eachRoom.alreadySelected && !eachRoom.blockRoom) || [];
      if (!this.filteredItems.length) {
        this.errorPopup = this.rGuestBookMessages?.myReservation?.roomNotFoundErrorText || 'Room not available';
        this.modifiyResService.updatedRoom = [];
      }
    }
  }

  moveSelectedRoomToTop(existingSelectedRoomIndex, isInitialCall) {
    if (existingSelectedRoomIndex >= 1) {
      const selectedItem = this.filteredItems.splice(existingSelectedRoomIndex, 1)[0];
      this.filteredItems.unshift(selectedItem);
      this.selectRoom(selectedItem, isInitialCall); // preload already selected room in array by default
    } else if (existingSelectedRoomIndex === 0) {
      this.selectRoom(this.filteredItems[0], isInitialCall); // preload already selected room in array by default
    }
  }

  closeTab(closeTab) {
    this.closeDetailTab(closeTab);
    setTimeout(() => {
      let windowHeight = $(window).height();
      let header = $('#headerItem').outerHeight();
      let roomData = $('#scrollingItem').outerHeight();
      console.log(windowHeight, header, roomData);

      if (windowHeight > header + roomData) {
        console.log('Height modification required');
        this.fullscreenView = true;
      } else {
        console.log('Height modification not required');
        this.fullscreenView = false;
      }
    }, 1000);
  }

  openCanellationDepositPolicy(selectedRoom) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false;
    dialogConfig.panelClass = 'overflowAutoClass';
    dialogConfig.maxWidth = 600;
    dialogConfig.data = {
      depositPolicy: selectedRoom.depositDescription,
      depositAmount: selectedRoom.depositAmountDue,
      cancellationPolicy: selectedRoom.cancelDescription,
      cancellationDueDate: selectedRoom.cancelDueDate,
      cancellationAmount: selectedRoom.cancelAmountDue,
    };
    const dialogRef = this.dialog.open(PolicyModalComponent, dialogConfig);

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      this.depositAndCancellationBtn['_elementRef'].nativeElement.classList.remove('cdk-program-focused', 'cdk-focused');
      setTimeout(() => {
        $('.modify_filter_title').trigger('click');
      }, 1000);
    });

    this.googleAnalyticsEventsService.eventEmitter(
      'deposit_and_cancellation_policy_button',
      'room',
      'depositAndCancellationViewed',
      `Offer Code - ${this.offerCode}, Casino Id - ${this.validateloyaltyService?.playerDetails?.casinoNumber || 'NA'}`
    );
  }

  closeDetailTab(closeTab) {
    this.previousRoom = '';
    this.closedvalue = true;
    this.previousIndex = 0;
    $('#showArrow' + this.scrollfix).css('display', 'none');
    $('#detailstab').insertAfter($('#scrollingItem'));
    this.details_tab = false;
  }

  showDetails(room, i) {
    if (this.previousRoom && this.previousRoom != room.roomName) {
      this.showMore = false;
      this.googleAnalyticsEventsService.eventEmitter(
        'room_details',
        'room',
        'room_details_closed',
        `OfferCode/RoomName -${this.offerCode}/${this.previousRoom}, Casino Id - ${
          this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'
        }`
      );
    }

    this.googleAnalyticsEventsService.eventEmitter(
      'room_details',
      'room',
      'room_details_viewed',
      `OfferCode/RoomName -${this.offerCode}/${room.roomName}, Casino Id - ${
        this.validateloyaltyService.playerDetails?.casinoNumber || 'NA'
      }`
    );
    this.googleAnalyticsEventsService.viewRoomItem(
      room,
      i,
      this.offerCode,
      this.validateloyaltyService?.playerDetails?.casinoNumber,
      this.configService?.PropertyData?.currencyCode,
      this.configService?.configDetailsData.propertyName,
      this.propertyId
    );
    this.previousRoom = room.roomName;

    this.scrollfix = i;
    this.room = room;

    this.showPanelPopupDisplayLogic(room);

    if (!this.details_tab) {
      this.details_tab = true;
    }

    this.viewDetailsAnimation();
    this.setCouroselTimer();
  }

  showPanelPopupDisplayLogic(room) {
    $('.showArrow').css('display', 'none');
    $('#showArrow' + this.scrollfix).css('display', 'block');

    this.selectedTab = room;
    $('#detailstab').insertAfter($('#room-panel' + this.getPosition(this.scrollfix)));
    $('#detailstab').addClass('detailstablist col-xs-12 col-sm-12 col-md-12 col-lg-12');
  }

  viewDetailsAnimation() {
    setTimeout(() => {
      let element = document.getElementById('detailstab');
      element.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
      $('#detailstab').addClass('animated pulse');
      let windowHeight = $(window).height();
      let header = $('#headerItem').outerHeight();
      let roomData = $('#scrollingItem').outerHeight();

      if (windowHeight > header + roomData) {
        this.fullscreenView = true;
      } else {
        this.fullscreenView = false;
      }
    }, 100);

    let IEorEdge = this.detectIE();
    setTimeout(() => {
      if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent) || IEorEdge) {
        console.log('moving...');
        $('html, body').animate({ scrollTop: $(window).scrollTop() - 100 + 'px' }, 1000);
      }
    }, 500);
  }

  detectIE() {
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf('MSIE ');
    if (msie > 0) {
      // IE 10 or older => return version number
      return true;
    }

    let trident = ua.indexOf('Trident/');
    if (trident > 0) {
      // IE 11 => return version number
      let rv = ua.indexOf('rv:');
      return true;
    }

    let edge = ua.indexOf('Edge/');
    if (edge > 0) {
      // Edge (IE 12+) => return version number
      return true;
    }

    // other browser
    return false;
  }

  errorRoomImageHandler(room, event, roomCode, imageName, isListIndex, index) {
    if (this.rGuestBookRoutePermissions?.functionalPermissions?.blockDefaultImage) {
      if (!isListIndex) {
        this.selectedTab.roomsImages.splice(index, 1);
      } else {
        event.target.src =
          (this.defaultRoomImageURL || 'https://rguestbookexpressprod.blob.core.windows.net/config/assets/images/default.jpg') +
          '?' +
          this.configService?.azureBlobTokenKey;
      }
    } else {
      event.target.src =
        (this.defaultRoomImageURL || 'https://rguestbookexpressprod.blob.core.windows.net/config/assets/images/default.jpg') +
        '?' +
        this.configService?.azureBlobTokenKey;
    }
  }

  updateModifiedRoomDetails(roomData, isInitialCall) {
    if (roomData) {
      roomData.guestDetails = this.processGuestInfo();
      if (isInitialCall) {
        this.modifiyResService.oldRoom = [_.cloneDeep(roomData)];
        this.modifiyResService.updatedRoom = [_.cloneDeep(roomData)];
      } else {
        // If the room list is empty (Arrival Date is in past),
        // isInitialCall as true will be executed
        // Setting the oldRoom and updatedRoom if it is empty even if isInitialCall is false
        this.assignInitialRoomData(roomData);
        this.assignUpdatedRoom(this.modifiyResService.updatedRoom[0], _.cloneDeep(roomData));
      }
      this.updatedRoomCode = this.modifiyResService.updatedRoom[0]?.room?.roomCode;
    }
  }

  getAddressLine(eachGuest) {
    return eachGuest['addressLine1']
      ? eachGuest['addressLine1'] + (eachGuest['addressLine2'] ? ', ' + eachGuest['addressLine2'] : '')
      : eachGuest['addressLine2']
      ? eachGuest['addressLine2']
      : '';
  }

  /**
   * Sets default dial code from admin portal configuration.
   *
   * @private
   * @memberof BookComponent
   */
  private setDefaultDialCode(): void {
    const dialCode = this.configService.PropertyData.dialCode;
    if (dialCode) {
      const arr = dialCode.split('|');
      this.defaultDialCode = arr[0];
    } else {
      this.defaultDialCode = '+1';
    }
  }

  processGuestInfo() {
    let processedGuestDetails = [];
    this.reservationData.guestInfo.forEach((eachGuest, index) => {
      processedGuestDetails.push({
        id: index,
        title: eachGuest['title'],
        empTitle: eachGuest['title'] === '',
        fName: eachGuest['firstName'],
        empFName: eachGuest['firstName'] === '',
        lName: eachGuest['lastName'],
        empLName: eachGuest['lastName'] === '',
        email: eachGuest.emailAddresses?.[0]?.emailAddress,
        empEmail: !eachGuest.emailAddresses?.[0]?.emailAddress,
        mobile: eachGuest.phoneNumbers?.[0]?.phoneNumber,
        empMobile: !eachGuest.phoneNumbers?.[0]?.phoneNumber,
        dialCode: eachGuest.phoneNumbers?.[0]?.dialCode ? '+' + eachGuest.phoneNumbers?.[0]?.dialCode : this.defaultDialCode,
        address: this.getAddressLine(eachGuest),
        addressLine1: eachGuest['addressLine1'] || '',
        addressLine2: eachGuest['addressLine2'] || '',
        empAddress: eachGuest['addressLine1'] + eachGuest['addressLine2'] === '',
        city: eachGuest['cityName'],
        empCity: eachGuest['cityName'] === '',
        state: eachGuest['stateProvinceCode'],
        postalCode: eachGuest['postalCode'],
        empPostalCode: eachGuest['postalCode'] === '',
        country: eachGuest['countryCode'],
        empCountry: eachGuest['countryCode'] === '',
        empState: eachGuest['stateProvinceCode'] === '',
        comments: '',
        casinoNo: eachGuest['casinoNumber'],
        sameAddress: false,
        sameDetails: false,
        isCasinoPlayer: eachGuest['casinoNumber'] ? true : false,
        isLoginPlayer: false,
        isAddedPlayer: false,
        Authorized: true,
        casinoValidateFalse: false,
        addNameId: eachGuest.addNameId,
        maskedEmail: this.modifiyResService.mask(eachGuest.emailAddresses?.[0]?.emailAddress),
        maskedMobile: this.modifiyResService.mask(eachGuest.phoneNumbers?.[0]?.phoneNumber),
        maskedAddress: this.modifiyResService.mask(eachGuest['addressLine1'] + ' ' + eachGuest['addressLine2']),
        maskedCity: this.modifiyResService.mask(eachGuest['cityName']),
        maskedState: this.modifiyResService.mask(eachGuest['stateProvinceCode']),
        maskedPostalCode: this.modifiyResService.mask(eachGuest['postalCode']),
        maskedCountry: this.modifiyResService.mask(eachGuest['countryCode']),
      });
    });
    return processedGuestDetails;
  }

  selectRoom(room, isInitialCall = false) {
    room.hasEnhancement = false;
    let roomDetail = new Roomdata(
      room.expandedDescription,
      room.blockRoom,
      room.compDays,
      room.days,
      room.hasComp,
      room.minRate,
      room.minRateTax,
      room.thead,
      room.tbody,
      room.roomsImages,
      room.previousPlayerStay,
      room.wing,
      room.roomType,
      room.roomCode,
      room.roomName,
      room.cancellationPolicy,
      room.depositPolicy,
      room.rateSnapshot,
      room.roomTotal,
      room.roomTaxTotal,
      room.recurringChargesTotalTax,
      room.quoteGrandTotal,
      room.roomTypeAvailable,
      room.roomSequence,
      room.resortFeeTotalTax,
      room.recurringChargesTotal,
      room.cancelDescription,
      room.depositDueDate,
      room.resortFeeTotal,
      room.depositAmountDue,
      room.cancelAmountDue,
      room.cancelDueDate,
      room.quoteTotalTax,
      room.depositDescription,
      room.quoteTotal,
      room.hasEnhancement,
      room.recurringChargesEnhancementTotal,
      room.resortFeeEnhancementTotal,
      room.roomSoldOut,
      this.showRemainingRoomsCount,
      room.isPackage
    );
    roomDetail.thead.forEach((element) => {
      if (element == 'roomTheadResortFee') {
        roomDetail['hasResortFee'] = true;
      }
      if (element == 'roomTheadOtherFee') {
        roomDetail['hasOtherFee'] = true;
      }
    });
    let proceesedData = this.bookService.putValue(
      roomDetail,
      this.arrivalDate,
      this.departureDate,
      this.casinoNumber,
      this.offerCode,
      [], //thead
      this.configService?.multiGuestType,
      this.configService?.multiGuestType ? this.configService?.guestTypeLimit : this.guestAdultCount,
      '',
      this.offerCode,
      this.configService.gettenantId(),
      this.configService.getpropertyId(),
      '',
      true
    );
    this.updateModifiedRoomDetails(proceesedData, isInitialCall);
  }

  /**
   *
   * @param index
   * @param prevDiff
   * @returns
   * RECURSIVE function to calculate the right most room element of the selected row
   * Room details will be displayed next to this right most room element
   */
  private getPosition(index, prevDiff = Infinity) {
    const parentElement = document.getElementById('scrollingItem');
    const parentRect = parentElement?.getBoundingClientRect();

    const element = document.getElementById('room-panel' + index);

    if (!element) {
      // Element does not exist in the incremented index. Return previous element
      return index - 1;
    }

    const rect = element?.getBoundingClientRect();

    let rightDiff = parentRect?.right - rect?.right;

    if (rightDiff >= prevDiff) {
      // Previous element is closer to the right end. Return the previous position
      return index - 1;
    }

    // Calculate the right distance of next element.
    // If it is closer to the right edge than the current element, return next element
    return this.getPosition(++index, rightDiff);
  }

  private assignUpdatedRoom(updatedDetails, roomData) {
    updatedDetails.room = roomData.room;
    const roomFilterKeys: string[] = [
      'arrival',
      'departure',
      'adults',
      'children',
      'infants',
      'juniors',
      'disablePeople',
      'casinoNumber',
      'offerCode',
    ];
    roomFilterKeys?.forEach((modelKey) => {
      if (roomData?.hasOwnProperty(modelKey)) {
        updatedDetails[modelKey] = roomData?.[modelKey];
      }
    });
  }

  private updateGuestCount() {
    this.configService.guestTypeLimit?.forEach((element) => {
      switch (element?.key) {
        case this.GuestCountKeys.noOfAdults:
          element.selectedValue = this.guestAdultCount;
          break;

        case this.GuestCountKeys.noOfJuniors:
          element.selectedValue = this.guestJuniorCount;
          break;

        case this.GuestCountKeys.noOfChildren:
          element.selectedValue = this.guestChildCount;
          break;

        case this.GuestCountKeys.noOfInfants:
          element.selectedValue = this.guestInfantCount;
          break;

        case this.GuestCountKeys.noOfDiscChild:
          element.selectedValue = this.guestDiscInfantCount;
          break;
      }
    });
  }

  private assignInitialRoomData(roomData) {
    if (!this.modifiyResService.oldRoom?.length) {
      this.modifiyResService.oldRoom = [_.cloneDeep(roomData)];
    }

    if (!this.modifiyResService.updatedRoom?.length) {
      this.modifiyResService.updatedRoom = [_.cloneDeep(roomData)];
    }
  }
  deSelectRoom(room) {
    this.updatedRoomCode = '';
    let timeIndex = this.filteredItems.findIndex((room) => room.alreadySelected);
    if (timeIndex >= 0) {
      this.selectRoom(this.filteredItems[timeIndex]);
    }
  }
}
